import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  text: '',
  voice: '',
  rate: 1,
  pitch: 1,
  volume: 1,
  isPlaying: false,
  isPaused: false,
  availableVoices: [],
  error: null,
  // Pronunciation Dictionary — user-defined word replacements that only
  // affect what gets SPOKEN, never the text shown on screen.
  pronunciationPairs: [],
}

const ttsSlice = createSlice({
  name: 'tts',
  initialState,
  reducers: {
    setText: (state, action) => {
      state.text = action.payload
    },
    setVoice: (state, action) => {
      state.voice = action.payload
    },
    setRate: (state, action) => {
      state.rate = action.payload
    },
    setPitch: (state, action) => {
      state.pitch = action.payload
    },
    setVolume: (state, action) => {
      state.volume = action.payload
    },
    setAvailableVoices: (state, action) => {
      state.availableVoices = action.payload
      if (!state.voice && action.payload.length > 0) {
        state.voice = action.payload[0].name
      }
    },
    setPlaying: (state, action) => {
      state.isPlaying = action.payload
      if (action.payload) {
        state.isPaused = false
      }
    },
    setPaused: (state, action) => {
      state.isPaused = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    clearTtsState: (state) => {
      state.text = ''
      state.isPlaying = false
      state.isPaused = false
      state.error = null
    },
    // Pronunciation Dictionary reducers
    addPronunciationPair: (state, action) => {
      state.pronunciationPairs.push({
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
        from: action.payload.from,
        to: action.payload.to,
      })
    },
    removePronunciationPair: (state, action) => {
      state.pronunciationPairs = state.pronunciationPairs.filter(
        (p) => p.id !== action.payload
      )
    },
  },
})

export const {
  setText,
  setVoice,
  setRate,
  setPitch,
  setVolume,
  setAvailableVoices,
  setPlaying,
  setPaused,
  setError,
  clearTtsState,
  addPronunciationPair,
  removePronunciationPair,
} = ttsSlice.actions

export default ttsSlice.reducer